import { j as jsxRuntimeExports } from "./auth-service-tools177.js";

function NativeScrollArea(_ref) {
  let {
    children
  } = _ref;
  return /* @__PURE__ */jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {
    children
  });
}

export { NativeScrollArea };